export enum LoggerLevel {
    Constructor = 'Constructor',
    Function = 'Function',
    Debug = 'Debug',
    State = 'State',
    ProcessEnvironment = 'ProcessEnvironment',
    UseEffect = 'UseEffect',
    HttpRequest = 'HttpRequest',
    ReducerState = 'ReducerState',
    Message = 'Message',
    ApiMessage = 'ApiMessage',
    Error = 'Error',
    Warning = 'Warning',
    Info = 'Info',
    SpinSummary = 'SpinSummary',
    GameStart = 'GameStart'
}

export enum LoggerSource {
    Game = 'Game',
    React = 'React',
    Ext = 'Ext',
    WebSocketService = 'WebSocketService',
    RestMessages = 'RestMessages',
    WebSocketMessages = 'WebSocketMessages',
    HttpService = 'HttpService',
    UIActions = 'UIActions'
}
